<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <div class="selectBox">
      <div class="inquireForm">
        <label>{{placeholder}}  <span style="color:red;" v-if="is_required">※必須</span> <span style="color:rgb(121, 121, 121);" v-if="!is_required">※任意</span>
        <strong class="error" v-if="!checkValid">{{error_message}}</strong></label>
        <input :type="input_type" class="formItem" ref="input_value" v-model="input_value" :placeholder="placeholder" @keyup.enter="submit">

        <div class="mt-5">
          <v-row no-gutters v-for="(item, index) in confirmation.items" v-bind:key="index">
            <v-col cols="auto">
              <v-checkbox
                  v-model="item.default"
                  class="mt-0 confirmation-checkbox"
                  :color="bot_setting.main_color"
                >
              </v-checkbox>
            </v-col>
            <v-col class="mt-1">
                <span style="white-space: pre-wrap;" v-html="item.value"></span>
            </v-col>
          </v-row>
          <div class="my-2 red--text darken-1 confirmation-message" v-if="confirmationValid == false">{{confirmation.error_message}}</div>
        </div>
      </div>
      <div class="mt-5 px-10" v-if="isFinalQuestion()">
        <div><span style="font-size:small; font-weight:bold">弁護士法人ネクサス法律事務所は個人情報の保護に取り組んでおります。</span></div>
        <div><span style="font-size:small">ご入力いただいた個人情報は、<a href="../privacy.html" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に基づいて適切に取り扱います。内容をご確認いただき、同意の上で下記ボタンを押してください。</span></div>
      </div>
      <div class="submitBtn">
        <button :id="label_name" @click="submit" v-if="isFinalQuestion()" class="btn-final">プライバシーポリシーに<br>同意して送信</button>
        <button :id="label_name" @click="submit" v-else>次へ</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: "TextFieldInput",

  props: ['placeholder', 'error_message', 'pattern_match', 'bot_setting', 'is_required', 'answer_type', 'label_name', 'confirmation'],

  created(){
    if (this.answer_type == 'email'){
      this.input_type = 'email'
    }
    if (this.answer_type == 'phone-number-no-hyphen' || this.answer_type == 'phone-number-hyphen' || this.answer_type == 'phone-number-both'){
      this.input_type = 'tel'
    }
  },

  data: () =>({
    input_value: "", 
    checkValid: true,
    input_type:'text',
    confirmationValid: true
  }),

  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      const button = document.getElementById(this.label_name)
      button.disabled = true
      if (this.validateInput() == true){
        this.checkValid = true
          if (this.validateConfirmation() == true) {
          var emitValue = {user_chat_message: this.input_value, user_chat_value:this.input_value}
          this.$emit('text_input_submitted', emitValue)
          this.input_value = ''
        }
      }else{
        this.confirmationValid = true
        this.checkValid = false
        this.$nextTick(()=>this.$refs.input_value.focus())
      }
      button.disabled = false
    },
    validateInput(){
      //console.log(this.input_value)
      if (this.is_required == true){
        if (this.input_value == null || this.input_value == ""){
          return false
        }
      }
      if (this.pattern_match != null || this.pattern_match != ""){
        var regex = new RegExp(this.pattern_match)
        if (regex.test(this.input_value)){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    },
    validateConfirmation(){
      this.confirmationValid = true
      for(var i=0; i < this.confirmation.items.length; i++){
        if (this.confirmation.items[i].default == false){
          this.confirmationValid = false
        }
      }
      if (this.confirmationValid == true) {
        return true
      }
      return false
    },
    isFinalQuestion(){
      if (this.label_name.indexOf('final') === 0){
        return true
      }else{
        return false
      }
    }
  }

}
</script>